export function getCSSFSpot(engagementId) {
  return JSON.parse(window.localStorage.getItem(`CSSF-${engagementId}`));
}

export function storeCSSFSpot(engagementId, location = {}) {
  if (!engagementId)
    throw new Error(`engagement id ${engagementId} is not valid`);
  if (!location.section || !location.subsection)
    throw new Error(`${JSON.stringify(location)} is an invalid location`);
  return window.localStorage.setItem(
    `CSSF-${engagementId}`,
    JSON.stringify(location)
  );
}

export function getSectionById(sections, id) {
  if (!sections || sections.length <= 0) {
    return null;
  }

  // Section ids are never "0", but it is a magical number that indicates "the first section"
  if (id === "0") {
    return sections[0];
  } else {
    return sections.find(section => section.id === id);
  }
}
